import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { IconFlagCA, IconFlagIN, IconFlagUS } from "material-ui-flags";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
// import FilterTable from '../components/filtertable';
import http from "../services/httpService";
import staticFiles from "../services/staticApi";
import {
  investorindividualRequestPath,
  getDate,
  investmentPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

const getFlags = (country) => {
  let CountryMapper = {
    India: IconFlagIN,
    USA: IconFlagUS,
    Canada: IconFlagCA,
  };
  if (country && CountryMapper[country]) {
    return React.createElement(CountryMapper[country]);
  } else {
    return React.createElement(CountryMapper["India"]);
  }
};

const getCurrency = (name) => {
  let currencyMapper = {
    INR: "₹",
    USD: "$",
    CAD: "C$",
  };
  if (name && currencyMapper[name]) {
    return currencyMapper[name];
  } else {
    return currencyMapper["INR"];
  }
};
const columns = [
  { id: "Country_locname", label: "Country", minWidth: 170 },
  { id: "Allocation", label: "Allocation", minWidth: 150 },
  { id: "Inv_Name_Type__companyname", label: "Investment Name", minWidth: 150 },
  { id: "Inv_Name_Type__type", label: "Asset Type", minWidth: 150 },
  { id: "Adviced_Date", label: "Advised Date", minWidth: 150, format: "Date" },
  { id: "asset_range", label: "Buy Range", minWidth: 150 },
  {
    id: "Research_Note",
    label: "Research Note",
    minWidth: 150,
    format: "link",
  },
  // { id: 'lookupparam2', label: 'Comment', minWidth: 150 },
];
const columnsAdviced = [
  { id: "Country", label: "Country", minWidth: 170 },
  { id: "advisedval", label: "Allocation", minWidth: 150, format: "currency" },
  { id: "name", label: "Investment Name", minWidth: 150 },
  { id: "type", label: "Asset Type", minWidth: 150 },
  { id: "Adviced_Date", label: "Invested Date", minWidth: 150, format: "Date" },
  { id: "buy_value", label: "Buy Value", minWidth: 150, format: "currency" },
  { id: "quantity", label: "Quantity", minWidth: 150 },
  {
    id: "currentval",
    label: "Current Value",
    minWidth: 150,
    format: "currency",
  },
  { id: "gainper", label: "Gain %", minWidth: 150 },

  // { id: 'lookupparam2', label: 'Comment', minWidth: 150 },
];
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
function InvestmentAdvice() {
  const classes = useStyles();
  let history = useHistory();
  const location = useLocation();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const [ActualInvestmentAdviceRows, setActualInvestmentAdviceRows] =
    React.useState([]);
  const myparam = location.state;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const gotoParent = () => {
    if (
      myparam &&
      myparam.cust_id &&
      !isNaN(myparam.cust_id) &&
      myparam.individual &&
      location.id
    ) {
      myparam.customer_id = Number(myparam.cust_id);
      history.push({
        pathname: investorindividualRequestPath,
        state: {
          // tab: "Investments",
          page: myparam.page,
          customer_id: location.id,
        },
        userid: location.userid,
      });
    } else {
      history.push({
        pathname: investmentPath,
        state: { tab: "Investments", page: myparam.page },
        userid: location.userid,
      });
    }

    // else {

    //     history.push({
    //         "pathname": investmentPath, state: { tab: "Investments", page: myparam.page}
    //     });
    // }
  };
  const [del, setDel] = useState(false);
  useEffect(() => {
    if (myparam && myparam.cust_id && myparam.Request_ID) {
      http
        .get(
          "/invrequestviewadvice/" + myparam.cust_id + "/" + myparam.Request_ID
        )
        .then((response) => {
          if (response.data.delete === true) {
            setDel(true);
          }
          if (
            response &&
            response.data &&
            response.data.Investment_Advice &&
            Array.isArray(response.data.Investment_Advice) &&
            response.data.Investment_Advice.length > 0
          ) {
            // if(response && response.data && response.data.length>0){
            setRows(response.data.Investment_Advice);
          }
          if (
            response &&
            response.data &&
            response.data.Actual_Investment_Advice &&
            Array.isArray(response.data.Actual_Investment_Advice) &&
            response.data.Actual_Investment_Advice.length > 0
          ) {
            setActualInvestmentAdviceRows(
              response.data.Actual_Investment_Advice
            );
          }
        })
        .catch((error) => {
          toast.error("Advice Details not found..!");
        });
    } else {
      history.goBack();
    }
  }, []);

  // (myparam);

  const [open, setOpen] = React.useState(false);
  const [delComment, setDelComment] = React.useState("");

  const handleClose = () => {
    setOpen(false);
    setDelComment("");
  };

  const openModel = () => {
    setOpen(true);
    setDelComment("");
  };

  const handleCommentChange = (e) => {
    setDelComment(e.target.value);
  };

  const sendParams = {
    cust_id: myparam.cust_id,
    req_id: myparam.Request_ID,
    comment: delComment,
  };

  //   (location.id);
  const submitDelete = () => {
    http
      .post("/delete-advise", sendParams)
      .then((res) => {
        if (res.data.statusCode === 0) {
          toast.success(res.data.data);
          setDelComment("");
          //   history.push({
          //     pathname: investorindividualRequestPath,
          //     userid: location.userid,
          //   });

          history.push({
            pathname: investorindividualRequestPath,
            state: {
              tab: "Investments",
              page: myparam.page,
              customer_id: location.id,
            },
            userid: location.userid,
          });
        }
        if (res.data.statusCode === 1) {
          toast.error(res.data.error);
        }
      })
      .catch((err) => {});
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
      >
        <Grid container component="main">
          <Grid item xs={1} sm={1} md={1}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 10, borderRadius: 60 }}
              onClick={gotoParent}
            >
              Overview
            </Button>
          </Grid>
        </Grid>
      </AppBar>
      <Grid container>
        <Grid container style={{ marginTop: "10px" }}>
          <Grid item xs={false} sm={6} md={5} style={{ marginTop: 10 }}>
            <Button
              variant="outlined"
              color="default"
              startIcon={<ArrowBackIosIcon />}
              onClick={gotoParent}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={false} sm={6} md={6} style={{ marginTop: 10 }}>
            <Typography color="textPrimary" variant="h5">
              Investment Advice Request
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <div container style={{ marginTop: "30px" }}>
        {/* <div > */}
        <div>
          <Typography color="textPrimary" variant="h5">
            Investment Advice Details
          </Typography>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            marginTop: 20,
          }}
        >
          <div style={{ marginBottom: 25 }}>
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              // className={"mt30"}
              style={{ height: "auto", padding: "5px 0", width: 300 }}
            />
          </div>

          <div style={{ marginBottom: 25 }}>
            {/* {localStorage.getItem("empRole") === "CEO" ? ( */}
            {del ? (
              <Button
                onClick={openModel}
                variant="contained"
                color="primary"
                size="large"
              >
                {" "}
                Delete Request
              </Button>
            ) : (
              ""
            )}
            {/* ) : ( "" )} */}
          </div>
          <TablePagination
            rowsPerPageOptions={[5]}
            component="div"
            count={ActualInvestmentAdviceRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        {/* </div> */}

        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={(e) =>
                          handleRequestSort(e, column.id, column.format)
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                      >
                        {columns.map((column, index) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                            >
                              {column.id === "Country_locname" ? (
                                <>
                                  <IconButton>
                                    {getFlags(row["Country"][0]["locname"])}
                                  </IconButton>
                                  {row["Country"][0]["locname"]}
                                </>
                              ) : column.format === "Date" ? (
                                getDate(value)
                              ) : column.id === "Allocation" ? (
                                getCurrency(row["Country"][0]["currency"]) +
                                " " +
                                value
                              ) : column.format === "link" &&
                                value &&
                                value !== "" ? (
                                <Link
                                  variant="body2"
                                  href={staticFiles + value}
                                  target="_blank"
                                >
                                  {value}
                                </Link>
                              ) : column.id === "Inv_Name_Type__companyname" &&
                                row["Inv_Name_Type"] &&
                                Array.isArray(row["Inv_Name_Type"]) &&
                                row["Inv_Name_Type"].length > 0 ? (
                                row["Inv_Name_Type"][0]["companyname"]
                              ) : column.id === "Inv_Name_Type__type" &&
                                row["Inv_Name_Type"] &&
                                Array.isArray(row["Inv_Name_Type"]) &&
                                row["Inv_Name_Type"].length > 0 ? (
                                row["Inv_Name_Type"][0]["type"]
                              ) : value ? (
                                value
                              ) : (
                                "N/A"
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>

      <Grid container style={{ marginTop: "30px" }}>
        <Grid item xs={12}>
          <Typography color="textPrimary" variant="h5">
            Actual Investment
          </Typography>
        </Grid>
        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  {columnsAdviced.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={(e) =>
                          handleRequestSort(e, column.id, column.format)
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {ActualInvestmentAdviceRows.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index + "a"}
                    >
                      {columnsAdviced.map((column, index) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={index + column.id}
                            align={column.align}
                          >
                            {column.id === "Country" ? (
                              <>
                                <IconButton>{getFlags(value)}</IconButton>
                                {value}
                              </>
                            ) : column.format === "Date" ? (
                              getDate(value)
                            ) : column.format === "currency" && value ? (
                              getCurrency(value) + " " + value
                            ) : column.format === "link" &&
                              value &&
                              value !== "" ? (
                              <Link
                                variant="body2"
                                href={staticFiles + value}
                                target="_blank"
                              >
                                {value ? value : "N/A"}
                              </Link>
                            ) : value ? (
                              value
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <Typography>Add your reason for deletion</Typography>
        </DialogContent>
        <input
          type="text"
          style={{
            height: 70,
            display: "block",
            margin: "15px 20px",
            outline: 0,
            borderRadius: 5,
            border: "1px solid black",
          }}
          onChange={handleCommentChange}
        />
        <DialogContent>
          <span>
            <b>Note:</b> The records deleted cannot be reverted
          </span>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button
              autoFocus
              onClick={submitDelete}
              variant="contained"
              color="primary"
            >
              Update
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default InvestmentAdvice;
